import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ArrowRight } from 'lucide-react';
export function SupportPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    workEmail: '',
    company: '',
    title: '',
    description: '',
    impact: '',
    affected: '',
    dateStarted: '',
    stillHappening: true,
    frequency: '',
    environment: '',
    version: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const emailBody = `
Full Name: ${formData.fullName}
Work Email: ${formData.workEmail}
Company: ${formData.company}

Issue: ${formData.title}
Impact: ${formData.impact || 'Not specified'}
Affected: ${formData.affected || 'Not specified'}

When it started: ${formData.dateStarted || 'Not specified'} (Still happening: ${formData.stillHappening ? 'Yes' : 'No'})
Frequency: ${formData.frequency || 'Not specified'}
Environment: ${formData.environment || 'Not specified'} (Version: ${formData.version || 'Not specified'})

Description:
${formData.description}
    `.trim();
    const mailtoLink = `mailto:support@meetsynthia.ai?subject=Support Request: ${encodeURIComponent(formData.title)}&body=${encodeURIComponent(emailBody)}`;
    window.location.href = mailtoLink;
    // Optional: Reset form after a delay
    setTimeout(() => {
      setFormData({
        fullName: '',
        workEmail: '',
        company: '',
        title: '',
        description: '',
        impact: '',
        affected: '',
        dateStarted: '',
        stillHappening: true,
        frequency: '',
        environment: '',
        version: ''
      });
    }, 1000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    if (type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData({
        ...formData,
        [name]: checked
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-2722">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2723">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2724">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2725">
            <Link to="/" data-id="element-2726">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2727" />
            </Link>
            <Navigation data-id="element-2728" />
          </div>
        </div>
      </header>

      <main className="pt-20" data-id="element-2729">
        {/* Hero Section */}
        <section className="relative w-full pt-20 pb-16 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-2730">
          <div className="absolute top-0 right-0 pointer-events-none" style={{
          width: '100%',
          height: '800px'
        }} data-id="element-2731">
            <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[2%] w-[100%] h-auto opacity-90" data-id="element-2732" />
          </div>

          <div className="max-w-7xl mx-auto relative z-10" data-id="element-2733">
            <div className="flex flex-col space-y-8" data-id="element-2734">
              <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 w-fit" data-id="element-2735">
                <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-2736">
                  SUPPORT
                </span>
              </div>

              <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-6xl font-['Syne']" data-id="element-2737">
                How can we help?
              </h1>

              <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-none font-light whitespace-nowrap" data-id="element-2738">
                Submit a support request and our team will respond within one
                business day.
              </p>
            </div>
          </div>
        </section>

        {/* Form Section */}
        <section className="py-16 px-6 md:px-12 lg:px-24 bg-white" data-id="element-2739">
          <div className="max-w-3xl mx-auto" data-id="element-2740">
            <form onSubmit={handleSubmit} className="space-y-10" data-id="element-2741">
              {/* User Info Section */}
              <div className="space-y-6" data-id="element-2742">
                <h3 className="text-xl font-bold text-black font-['Syne'] border-b border-gray-100 pb-2" data-id="element-2743">
                  Your Information
                </h3>

                <div data-id="element-2744">
                  <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2745">
                    Full name <span className="text-red-500" data-id="element-2746">*</span>
                  </label>
                  <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2747" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2748">
                  <div data-id="element-2749">
                    <label htmlFor="workEmail" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2750">
                      Work email <span className="text-red-500" data-id="element-2751">*</span>
                    </label>
                    <input type="email" id="workEmail" name="workEmail" value={formData.workEmail} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2752" />
                  </div>

                  <div data-id="element-2753">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2754">
                      Company / workspace name{' '}
                      <span className="text-red-500" data-id="element-2755">*</span>
                    </label>
                    <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2756" />
                  </div>
                </div>
              </div>

              {/* Issue Details Section */}
              <div className="space-y-6" data-id="element-2757">
                <h3 className="text-xl font-bold text-black font-['Syne'] border-b border-gray-100 pb-2 mt-8" data-id="element-2758">
                  Issue Details
                </h3>

                <div data-id="element-2759">
                  <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2760">
                    Short title / summary{' '}
                    <span className="text-red-500" data-id="element-2761">*</span>
                  </label>
                  <input type="text" id="title" name="title" value={formData.title} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2762" />
                </div>

                <div data-id="element-2763">
                  <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2764">
                    Detailed description <span className="text-red-500" data-id="element-2765">*</span>
                  </label>
                  <textarea id="description" name="description" value={formData.description} onChange={handleChange} required rows={6} placeholder="Describe the issue in detail. Include steps to reproduce if applicable..." className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2766" />
                </div>
              </div>

              {/* Impact & Environment Section */}
              <div className="space-y-6" data-id="element-2767">
                <h3 className="text-xl font-bold text-black font-['Syne'] border-b border-gray-100 pb-2 mt-8" data-id="element-2768">
                  Impact & Environment{' '}
                  <span className="text-sm font-normal text-gray-400" data-id="element-2769">
                    (optional)
                  </span>
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2770">
                  <div data-id="element-2771">
                    <label htmlFor="impact" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2772">
                      Impact level
                    </label>
                    <select id="impact" name="impact" value={formData.impact} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent bg-white" data-id="element-2773">
                      <option value="" data-id="element-2774">Select impact</option>
                      <option value="Blocker" data-id="element-2775">Blocker (system down)</option>
                      <option value="High" data-id="element-2776">
                        High (major workflow impacted)
                      </option>
                      <option value="Medium" data-id="element-2777">Medium</option>
                      <option value="Low" data-id="element-2778">Low</option>
                    </select>
                  </div>

                  <div data-id="element-2779">
                    <label htmlFor="affected" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2780">
                      Who is affected
                    </label>
                    <select id="affected" name="affected" value={formData.affected} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent bg-white" data-id="element-2781">
                      <option value="" data-id="element-2782">Select scope</option>
                      <option value="Just me" data-id="element-2783">Just me</option>
                      <option value="My team" data-id="element-2784">My team</option>
                      <option value="Whole org" data-id="element-2785">Whole org</option>
                      <option value="External users/customers" data-id="element-2786">
                        External users/customers
                      </option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2787">
                  <div data-id="element-2788">
                    <label htmlFor="dateStarted" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2789">
                      When it started (First noticed)
                    </label>
                    <div className="flex items-center gap-4" data-id="element-2790">
                      <input type="date" id="dateStarted" name="dateStarted" value={formData.dateStarted} onChange={handleChange} className="flex-1 px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2791" />
                      <label className="flex items-center gap-2 cursor-pointer whitespace-nowrap" data-id="element-2792">
                        <input type="checkbox" name="stillHappening" checked={formData.stillHappening} onChange={handleChange} className="w-5 h-5 text-[#0066FF] border-gray-300 rounded focus:ring-[#0066FF]" data-id="element-2793" />
                        <span className="text-sm font-medium text-gray-700" data-id="element-2794">
                          Still happening?
                        </span>
                      </label>
                    </div>
                  </div>

                  <div data-id="element-2795">
                    <label htmlFor="frequency" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2796">
                      Frequency
                    </label>
                    <select id="frequency" name="frequency" value={formData.frequency} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent bg-white" data-id="element-2797">
                      <option value="" data-id="element-2798">Select frequency</option>
                      <option value="Always" data-id="element-2799">Always</option>
                      <option value="Often" data-id="element-2800">Often</option>
                      <option value="Sometimes" data-id="element-2801">Sometimes</option>
                      <option value="Once" data-id="element-2802">Once</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2803">
                  <div data-id="element-2804">
                    <label htmlFor="environment" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2805">
                      Environment
                    </label>
                    <select id="environment" name="environment" value={formData.environment} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent bg-white" data-id="element-2806">
                      <option value="" data-id="element-2807">Select environment</option>
                      <option value="Web" data-id="element-2808">Web</option>
                      <option value="iOS" data-id="element-2809">iOS</option>
                      <option value="Android" data-id="element-2810">Android</option>
                      <option value="API" data-id="element-2811">API</option>
                      <option value="Browser extension" data-id="element-2812">
                        Browser extension
                      </option>
                    </select>
                  </div>

                  <div data-id="element-2813">
                    <label htmlFor="version" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2814">
                      Version (Optional)
                    </label>
                    <input type="text" id="version" name="version" value={formData.version} onChange={handleChange} placeholder="e.g. 2.4.1 or Chrome 120" className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2815" />
                  </div>
                </div>
              </div>

              <div className="pt-6" data-id="element-2816">
                <button type="submit" className="w-full group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#0066FF] font-['Syne'] hover:bg-black hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" data-id="element-2817">
                  <span data-id="element-2818">SUBMIT REQUEST</span>
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-2819" />
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>

      <Footer data-id="element-2820" />
    </div>;
}